import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetGroupsQuery, useLazyGetGroupsQuery } from '../../redux/apis/usersManagement/users/uMUsersApiSlice'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateGroups from '../../components/users/EditCreateGroups'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const Groups = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetGroupsQuery({
    page: pagination.current,
    page_size: pagination.pageSize,
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },

    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_group') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = (paginationInfo) => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {can('add_group') && create ? (
        <EditCreateGroups
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      ) : null}
      {can('change_group') && edit ? (
        <EditCreateGroups
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      ) : null}

      <div className='flex ml-auto gap-4 mb-4'>
        <DownloadAllDataButton
          lazyQueryHook={useLazyGetGroupsQuery}
          fileName='groups'
        />
        {can('add_group') && (
          <button
            className='btn btn-outline-theme'
            onClick={() => setCreate(true)}
          >
            Create New Group
          </button>
        )}
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default Groups
